export default "__VITE_ASSET__BZrW02b5__"